import React, { useState } from "react"
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Input, Button, Label, Row, Col } from "reactstrap"
import { toast } from 'react-toastify';
import css from "components/QuoteModal.module.css"
import { sendMail } from "api"
import { numberWithCommas } from "utils"
import { useStore } from "store";
import { useTranslation } from "react-i18next";

const initialState = {
    email: "",
    country: "Slovakia",
    msg: "",
}

function QuoteModal({ data, isOpen, handleModal }) {
    const [state, setState] = useState(initialState)
    const { i18n } = useTranslation()
    const t = useStore(state => state.translations)

    const countries = [
        {
            name: "Czech republic",
            code: "cz"
        },
        {
          name: "Germany",
          code: "de"
        },
        {
            name: "Hungary",
            code: "hu"
        },
        {
            name: "Slovakia",
            code: "sk"
        }
    ]

    const { rotation, size, theme, table, ring, control, powerSupply } = useStore.getState()

    const options = {
        rotation: rotation && data.rotations[rotation],
        size: size && data.sizes[size],
        theme: theme && data.themes[theme],
        table: table && data.tables[table],
        ring: (rotation === "pole") ? false : (ring && data.rings[ring]),
        control: control && data.addons.control[control],
        power: powerSupply ? data.addons.powerSupply : false
    }

    // let themeImage = options.theme && options.theme.imageFront.url
    // let tableImage = options.table && options.table.imageFront.url
    // let ringImage = options.ring && options.ring.imageFront.url

    const basePrice = data.basePrice || 0

    // Final price, adding everything together
    const price = basePrice
      + (options.rotation ? options.rotation.price : 0)
      + (options.size ? options.size.price : 0)
      + (options.theme ? options.theme.price : 0)
      + (options.table ? options.table.price : 0)
      + (options.ring ? options.ring.price : 0)
      + (options.control ? options.control.price : 0)
      + (options.power ? options.power.price : 0)

    const preparedData = {
      items: [
        {
          type: "Rotation",
          label: options.rotation.label, // User have to pick rotation
          price: numberWithCommas(Number(options.rotation.price).toFixed(2)) + ' €'
        },
        {
          type: "Size",
          label: options.size.label, // User have to pick size
          price: numberWithCommas(Number(options.size.price).toFixed(2)) + ' €'
        },
        {
          type: "Theme",
          label: options.theme ? options.theme.label : "-",
          price: options.theme ? numberWithCommas(Number(options.theme.price).toFixed(2)) + ' €' : '0 €'
        },
        {
          type: "Table",
          label: options.table ? options.table.label : "-",
          price: options.table ? numberWithCommas(Number(options.table.price).toFixed(2)) + ' €' : '0 €'
        },
        {
          type: "Control",
          label: options.control ? options.control.label : "-",
          price: options.control ? numberWithCommas(Number(options.control.price).toFixed(2)) + ' €' : '0 €'
        },
        {
          type: "230V Power supply",
          label: options.power ? "Yes" : "No",
          price: options.power ? numberWithCommas(Number(options.power.price).toFixed(2)) + ' €' : '0 €'
        }
      ],
      totalPrice: price
    }

    if (options.ring) {
      preparedData.items.push({
        type: "Ring",
        label: options.ring ? options.ring.label : "-",
        price: options.ring ? numberWithCommas(Number(options.ring.price).toFixed(2)) + ' €' : '0 €'
      })
    }

    async function handleMail() {
        if (!state.email) {
            toast.error(`Email not provided!`, {
                autoClose: 5000,
            })
            return false
        }
        if (!state.country) {
            toast.error(`Country not provided!`, {
                autoClose: 5000,
            })
            return false
        }
        await toast.promise(
          sendMail({ 
            email: state.email,
            country: state.country,
            msg: `<b>New quote!</b><br /><br />
            
<b>From:</b> ${state.email}<br />
<b>Country</b>: ${state.country}<br />
<b>User's message</b>: ${state.msg}<br /><br />

<b>Here's the summary for the quote:</b><br /><br />

Rotation: ${options.rotation.label} (${numberWithCommas(Number(options.rotation.price).toFixed(2))} €)<br />
Size: ${options.size.label} (${numberWithCommas(Number(options.size.price).toFixed(2))} €)<br />
Theme: ${options.theme ? options.theme.label : "-"} (${options.theme ? numberWithCommas(Number(options.theme.price).toFixed(2)) + ' €' : '0 €'})<br />
Table: ${options.table ? options.table.label : "-"} (${options.table ? numberWithCommas(Number(options.table.price).toFixed(2)) + ' €' : '0 €'})<br />
Ring: ${options.ring ? options.ring.label : "-"} (${options.ring ? numberWithCommas(Number(options.ring.price).toFixed(2)) + ' €' : '0 €'})<br />
Control: ${options.control ? options.control.label : "-"} (${options.control ? numberWithCommas(Number(options.control.price).toFixed(2)) + ' €' : '0 €'})<br />
230V Power supply: ${options.power ? "Yes" : "No"} (${options.power ? numberWithCommas(Number(options.power.price).toFixed(2)) + ' €' : '0 €'})<br /><br />

<b>Total price: ${numberWithCommas(Number(price).toFixed(2))} €</b>
`
          }),
          {
            pending: `Sending email...`,
            success: `Email sent!`,
            error: `There was a problem with sending an email.`
          }
        );
    }

    const externalCloseBtn = <button className={css.closeButton} onClick={handleModal}>&times;</button>;

    return ( 
        <Modal isOpen={isOpen} className={css.modal} toggle={handleModal}>
            <ModalHeader className={css.modalHeader} toggle={handleModal} close={externalCloseBtn}>{t.quote.qetAQuote[i18n.language]}</ModalHeader>
                <ModalBody className={css.modalBody}>
                    <Form>
                        <Row>
                            <Col sm={6}>
                                <FormGroup className="mb-2">
                                    <Label for="email">Email</Label>
                                    <Input className={css.input} bsSize="sm" type="email" name="email" id="email" placeholder="Email" onChange={(e) => setState({...state, email: e.target.value })} />
                                </FormGroup>
                            </Col>
                            <Col sm={6}>
                                <FormGroup className="mb-2">
                                    <Label for="country">Country</Label>
                                    <Input className={css.input} type="select" name="select" id="country" onChange={(e) => setState({...state, country: e.target.value })} value={state.country}>
                                    {countries.map(country => (
                                        <option key={country.name} value={country.name}>{country.name}</option>
                                    ))}
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>
                        <FormGroup className="mb-2">
                            <Label for="msg">Your message</Label>
                            <Input className={css.input} bsSize="sm" type="textarea" name="msg" id="msg" placeholder="" rows="6" onChange={(e) => setState({...state, msg: e.target.value })} />
                        </FormGroup>
                    </Form>
                </ModalBody>
            <ModalFooter className={css.modalFooter}>
            <Button outline className={css.button} color="secondary" onClick={handleMail}>SEND</Button>
            </ModalFooter>
        </Modal>
     );
}

export default QuoteModal;